var Message = require('v4-stack/message');

function CommandHeader(service, cid) {
    this.service = service;
    this.cid = cid;
}

CommandHeader.prototype.toString = function() {
    return '<' + this.service + ', ' + this.cid.toString() + '>';
};

CommandHeader.createRequestHeader = function(service, cid) {
    return new CommandHeader(service, cid);
};

CommandHeader.prototype.createResponseHeader = function() {
    return new CommandHeader(this.service, this.cid);
};

CommandHeader.prototype.createErrorHeader = function() {
    return new CommandHeader(this.service, this.cid);
};


module.exports = CommandHeader;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/command-header.js
// module id = 198
// module chunks = 1